import { TabSwitcher } from '@aus-platform/design-system';
import { useAppSelector } from 'app/hooks';
import {
  selectMap3dDataset,
  selectMap3DState,
  selectMap3dWorkspace,
} from 'map-3d/shared/map-3d-slices';
import { useEffect, useState } from 'react';
import { LayerType } from 'shared/api';
import { Map3DNoAccessToFeature, Map3DNoTerrainSelected } from '../../shared';
import {
  restoreLayersVisibility,
  toggleLayersVisibilityExcludingTypes,
} from '../map-3d-workspace';
import { CleanupTabs } from './constants';
import { TerrainCleanupTabs } from './terrain-cleanup-tabs';

// Constants.
const TERRAIN_CLEANUP_VISIBLE_LAYER_TYPES = [
  LayerType.Orthomosaic,
  LayerType.CapturedDsm,
  LayerType.SlopeMap,
];

export const TerrainCleanup: React.FC = () => {
  // useStates.
  const [activeTabKey, setActiveTabKey] = useState(CleanupTabs.Generate);

  // Selectors.
  const { selectedTerrainIteration } = useAppSelector(selectMap3dDataset);
  const { workspaceLayers } = useAppSelector(selectMap3dWorkspace);
  const { aoiManager } = useAppSelector(selectMap3DState);

  // Effects.
  useEffect(() => {
    const previousVisibility = toggleLayersVisibilityExcludingTypes(
      workspaceLayers,
      TERRAIN_CLEANUP_VISIBLE_LAYER_TYPES,
      false,
    );
    aoiManager?.setVisibility(false);

    return () => {
      restoreLayersVisibility(workspaceLayers, previousVisibility);
      aoiManager?.setVisibility(true);
    };
  }, []);

  // Handlers.
  const handleTabChange = (activeTabKey: string) => {
    setActiveTabKey(activeTabKey);
  };

  // Renders.
  if (!selectedTerrainIteration?.id) {
    return <Map3DNoTerrainSelected />;
  }

  if (!selectedTerrainIteration.canManageIterations) {
    return <Map3DNoAccessToFeature />;
  }

  return (
    <div className="terrain-cleanup__container">
      <TabSwitcher
        tabComponentList={TerrainCleanupTabs}
        activeKey={activeTabKey}
        onTabSwitch={handleTabChange}
      />
    </div>
  );
};
